<div class="cf-flex-column cf-justify-content-center cf-align-items-center cf-fill">
  <mat-card appearance="outlined" aria-label="Register" class="register-card mat-elevation-z8">
    <mat-toolbar color="accent" class="header cf-flex-column cf-justify-content-space-between cf-align-items-center">
      <mat-toolbar-row class="cf-flex-row cf-justify-content-space-between cf-align-items-center">
        <button [routerLink]="['/login']" mat-button class="login-button">
          <mat-icon aria-hidden="false" aria-label="Login arrow backward icon">arrow_backward</mat-icon>
          <span [translate]="'UI.Login'"></span>
        </button>
        <h1 [translate]="'UI.Register'"></h1>
      </mat-toolbar-row>
      @if (isError) {
        <mat-toolbar-row class="error">
          <h2 [translate]="'UI.RegisterEmailTaken'"></h2>
        </mat-toolbar-row>
      }
    </mat-toolbar>
    <mat-card-content class="content">
      @let settings = settings$ | async;
      @if (settings) {
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <h2 class="section-title" [translate]="'UI.YourDetails'"></h2>
          <app-border></app-border>
          <div class="form-field cf-flex-row cf-justify-content-space-between cf-align-items-center cf-gap-20" style="margin-top: 0.5em">
            <mat-form-field class="half-width-form-field" appearance="outline">
              <mat-label [translate]="'UI.FirstName'"></mat-label>
              <input type="text" matInput formControlName="firstName" aria-label="first name" required />
              @if (firstName.invalid && (firstName.dirty || firstName.touched) && firstName.errors.required) {
                <mat-error [translate]="'UI.Error.Required'"></mat-error>
              }
            </mat-form-field>
            <mat-form-field class="half-width-form-field" appearance="outline">
              <mat-label [translate]="'UI.LastName'"></mat-label>
              <input type="text" matInput formControlName="lastName" aria-label="last name" required />
              @if (lastName.invalid && (lastName.dirty || lastName.touched) && lastName.errors.required) {
                <mat-error [translate]="'UI.Error.Required'"></mat-error>
              }
            </mat-form-field>
          </div>
          <mat-form-field class="form-field" appearance="outline">
            <mat-label [translate]="'UI.Company'"></mat-label>
            <input type="text" matInput formControlName="company" aria-label="company" required />
            @if (company.invalid && (company.dirty || company.touched) && company.errors.required) {
              <mat-error [translate]="'UI.Error.Required'"></mat-error>
            }
          </mat-form-field>
          <mat-form-field class="form-field" appearance="outline">
            <mat-label [translate]="'UI.Country'"></mat-label>
            @for (country of settings.Countries; track country.Code) {
              <mat-option [value]="country.Code">
                {{ country.TitleTextId | translate }}
              </mat-option>
            }
            @if (country.invalid && (country.dirty || country.touched) && country.errors.required) {
              <mat-error [translate]="'UI.Error.Required'"></mat-error>
            }
          </mat-form-field>
          <h2 class="section-title" [translate]="'UI.Account'"></h2>
          <app-border></app-border>
          <mat-form-field class="form-field" appearance="outline">
            <mat-label [translate]="'UI.Email'"></mat-label>
            <input type="email" matInput formControlName="email" aria-label="username" required autocomplete="username" />
            @if (email.invalid && (email.dirty || email.touched) && email.errors.email) {
              <mat-error [translate]="'UI.Error.InvalidEmail'"></mat-error>
            }
            @if (email.invalid && (email.dirty || email.touched) && email.errors.required) {
              <mat-error [translate]="'UI.Error.Required'"></mat-error>
            }
          </mat-form-field>
          <mat-form-field class="form-field" appearance="outline">
            <mat-label [translate]="'UI.Password'"></mat-label>
            <input
              type="password"
              matInput
              formControlName="password"
              aria-label="password"
              required
              autocomplete="current-password"
              (input)="onPasswordInput()"
            />
            @if (password.invalid && (password.dirty || password.touched) && password.errors.required) {
              <mat-error [translate]="'UI.Error.Required'"></mat-error>
            }
            @if (password.invalid && (password.dirty || password.touched) && password.errors.minlength) {
              <mat-error
                [translate]="'UI.Error.PasswordMinLength'"
                [translateParams]="{ numberOfMinCharacters: password.errors.minlength.requiredLength }"
              >
                ></mat-error
              >
            }
          </mat-form-field>
          <mat-form-field class="form-field" appearance="outline">
            <mat-label [translate]="'UI.ConfirmPassword'"></mat-label>
            <input
              type="password"
              matInput
              formControlName="confirmPassword"
              aria-label="confirm password"
              required
              (input)="onPasswordInput()"
            />
            @if (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched) && confirmPassword.errors.required) {
              <mat-error [translate]="'UI.Error.Required'"> ></mat-error>
            }
            @if (
              confirmPassword.invalid &&
              (confirmPassword.dirty || confirmPassword.touched) &&
              !confirmPassword.errors.required &&
              confirmPassword.errors.passwordMismatch
            ) {
              <mat-error [translate]="'UI.Error.PasswordsDoNotMatch'"> ></mat-error>
            }
          </mat-form-field>
          <mat-form-field class="form-field" appearance="outline">
            <mat-label [translate]="'UI.Language'"></mat-label>
            @for (language of settings.Languages; track language.Code) {
              <mat-option [value]="language.Code">
                {{ language.TitleTextId | translate }}
              </mat-option>
            }
            @if (language.invalid && (language.dirty || language.touched) && language.errors.required) {
              <mat-error [translate]="'UI.Error.Required'"></mat-error>
            }
          </mat-form-field>

          <button
            type="submit"
            mat-raised-button
            class="register-button primary-button"
            aria-label="register"
            [disabled]="!registerForm.valid || (isLoading$ | async)"
          >
            {{ 'UI.Register' | translate }}
          </button>
        </form>
      } @else {
        <div class="spinner cf-flex-row cf-justify-content-center cf-align-items-center">
          <app-spinner></app-spinner>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
